<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Non IATA Devre Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
        </v-layout>

        <v-container fluid="">
          <v-card color="grey lighten-1" flat>

            <v-container fluid>
              <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                <v-layout row wrap>

                  <v-flex xs12 sm4 md2>
                    <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" v-model="Rapor.BaslangicTarih"
                      v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md2>
                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="Rapor.BitisTarih"
                      v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihcomp>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="load">
                        <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                      </div>
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-form>
            </v-container>

            <v-container fluid="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <div class="card__text info white--text">
                    <h2>Satılan Biletler</h2>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout child-flex>
                    <v-card>
                      <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :loading="progress" :items="itemssatis"
                        :search="search3">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.HavayoluKodu }}</td>
                          <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                          <td class="text-xs-left">{{ props.item.UcusTip }}</td>
                          <td class="text-xs-left">{{ props.item.Cari.Kod}}</td>
                          <td class="text-xs-right">{{ props.item.BiletTutari}}</td>
                          <td class="text-xs-right">{{ props.item.VergiTutari}}</td>
                          <td class="text-xs-right">{{ props.item.IskontoTutari}}</td>
                          <td class="text-xs-right">{{ props.item.ServisTutari }}</td>
                          <td class="text-xs-right">{{ props.item.ReserveTutari }}</td>
                          <td class="text-xs-right">{{ props.item.KrediliTutar }}</td>
                          <td class="text-xs-right">{{ props.item.PesinTutar }}</td>
                          <td class="text-xs-right">{{ props.item.KrediKartTutar }}</td>
                          <td class="text-xs-left">{{ props.item.KrediKartNo }}</td>
                          <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                          <td class="text-xs-right">{{ props.item.CezaTutari }}</td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                      </v-data-table>
                    </v-card>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <div class="card__text orange darken-4 white--text">
                    <h3>Satış Toplamlar</h3>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4"></h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  İç Hat
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Dış Hat
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Genel
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Bilet Tutarı</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Ceza</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Vergi</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">İskonto</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Servis</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Reserve</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Kredili</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Peşin</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">R-Kredi Kartlı</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">C-Kartlı Tutar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">F-Kartlı Tutar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisIc.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisDis.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{satisGen.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-container>

            <v-container fluid="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <div class="card__text info white--text">
                    <h2>İade Edilen Biletler</h2>
                  </div>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-card>
                    <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :loading="progress" :items="itemsiade"
                      :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.HavayoluKodu }}</td>
                        <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                        <td class="text-xs-left">{{ props.item.UcusTip }}</td>
                        <td class="text-xs-left">{{ props.item.Cari.Kod}}</td>
                        <td class="text-xs-right">{{ props.item.BiletTutari}}</td>
                        <td class="text-xs-right">{{ props.item.VergiTutari}}</td>
                        <td class="text-xs-right">{{ props.item.IskontoTutari}}</td>
                        <td class="text-xs-right">{{ props.item.ServisTutari }}</td>
                        <td class="text-xs-right">{{ props.item.ReserveTutari }}</td>
                        <td class="text-xs-right">{{ props.item.KrediliTutar }}</td>
                        <td class="text-xs-right">{{ props.item.PesinTutar }}</td>
                        <td class="text-xs-right">{{ props.item.KrediKartTutar }}</td>
                        <td class="text-xs-left">{{ props.item.KrediKartNo }}</td>
                        <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                        <td class="text-xs-right">{{ props.item.CezaTutari }}</td>

                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <div class="card__text orange darken-4 white--text">
                    <h3>İade Toplamlar</h3>
                  </div>
                </v-flex>


                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">İade Toplamlar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  İç Hat
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Dış Hat
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Genel
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Bilet Tutarı</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Ceza</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Vergi</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">İskonto</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Servis</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Reserve</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Kredili</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Peşin</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">R-Kredi Kartlı</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">C-Kartlı Tutar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">F-Kartlı Tutar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeic.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeDis.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{iadeGen.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container fluid="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <div class="card__text orange darken-4white--text">
                    <h2>Genel Toplam</h2>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4"></h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  İç Hat
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Dış Hat
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-layout>
                            <v-flex sm11>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Genel
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                            <v-flex sm1>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  :
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Bilet Tutarı</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.BiletTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Ceza</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.CezaTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Vergi</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.VergiTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">İskonto</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.IskontoTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Servis</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.ServisTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Reserve</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.ReserveTutari}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Kredili</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.KrediliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">Peşin</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.PesinTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">R-Kredi Kartlı</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.RKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">C-Kartlı Tutar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.CKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <h5 class=" .font-weight-regular info--text mb-4">F-Kartlı Tutar</h5>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{genic.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gendis.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex sm12>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{gengen.FKartliTutar}} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>

                        </v-layout>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-container>

          </v-card>
        </v-container>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>


        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
          <v-card color="grey lighten-2">
            <v-card-title>Filtre Seçimi</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12>
                   <havayollaricomp :etiket="'Hava Yolu Kodu'"   v-model="havayolubil"></havayollaricomp>
                  <havayollaricomp :etiket="'Acenta Kodu'"   v-model="havayolubil2"></havayollaricomp>
                  <v-autocomplete hide-details="" v-model="Rapor.Masraf" :items="masrafmerkezi" label="Masraf Merkezi"
                    item-text="CodeName" clearable item-value="Code" max-height="400"></v-autocomplete>
                  </v-flex>


                  <v-flex xs12 sm12 md12>
                    <div class="card__text grey darken-1 white--text">
                    <h3>Opsiyonlar</h3>
                  </div>
                  </v-flex>

                <div class="flex md4">
                  <v-radio-group label="Bilet Tipi" v-model="Rapor.HatTipi" hide-details>
                    <v-radio :value="0" label="Hepsi"></v-radio>
                    <v-radio :value="1" label="İç Hat"></v-radio>
                    <v-radio :value="2" label="Dış Hat"></v-radio>
                    <v-radio :value="3" label="BSP"></v-radio>
                  <v-radio :value="3" label="BSP+ Dış"></v-radio>

                  </v-radio-group>
                </div>

                <div class="flex md4">
                  <v-radio-group label="Ödeme" v-model="Rapor.OdemeTipi" hide-details>
                    <v-radio :value="0" label="Hepsi"></v-radio>
                    <v-radio :value="1" label="Peşin"></v-radio>
                    <v-radio :value="2" label="Kredi Kartı"></v-radio>
                  </v-radio-group>
                </div>


                <div class="flex md4">
                  <v-radio-group label="Rapor Sırası" v-model="Rapor.RaporSira" hide-details>
                    <v-radio :value="0" label="Bilet Sırası"></v-radio>
                    <v-radio :value="1" label="Tarih Sırası"></v-radio>
                  </v-radio-group>
                </div>

                <div class="flex md6">
                  <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>
                </div>


              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
              <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihcomp'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"



  export default {
    data() {
      return {
        fiyatturu: [{
            text: 'AD-Yetişkin',
            value: 'AD'
          },
          {
            text: 'CHD-Çocuk',
            value: 'CHD'
          },
          {
            text: 'INF-Bebek',
            value: 'INF'
          },
          {
            text: 'TUS-Diplomatik',
            value: 'TUS'
          },
          {
            text: 'EX',
            value: 'EX'
          },
          {
            text: 'STD-Öğrenci',
            value: 'STD'
          },
          {
            text: 'SRC-Yaşlı',
            value: 'SRC'
          },
          {
            text: 'MIL-Asker',
            value: 'MIL'
          },
          {
            text: 'YTH-Genç',
            value: 'YTH'
          }
        ],
        doviztipi: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        havayolubil2: {
          havayolukodu: null,
          formno: null
        },
        search: '',

        headerssatis: [{
            text: 'HY',
            value: 'HavayoluKodu'
          },
          {
            text: 'Bilet No',
            value: 'BiletNo'
          },
          {
            text: 'Uçuş Tipi',
            value: 'UcusTip'
          },
          {
            text: 'Hesap',
            value: 'Cari.Kod'
          },
          {
            text: 'Bilet Tutarı',
            value: 'BiletTutari'
          },
          {
            text: 'Vergi',
            value: 'VergiTutari'
          },
          {
            text: 'Iskonto',
            value: 'IskontoTutari'
          },
          {
            text: 'Servis',
            value: 'ServisTutari'
          },
          {
            text: 'Reserve',
            value: 'ReserveTutari'
          },
          {
            text: 'Kredili',
            value: 'KrediliTutar'
          },
          {
            text: 'Peşin',
            value: 'PesinTutar'
          },
          {
            text: 'Kredi Kartlı',
            value: 'KrediKartTutar'
          },
          {
            text: 'Kredi Kart No',
            value: 'KrediKartNo'
          },
          {
            text: 'Fatura No',
            value: 'FaturaNo'
          },
          {
            text: 'Ceza',
            value: 'CezaTutari'
          }
        ],
        headervoid: [{
            text: 'HY',
            value: 'HavayoluKodu'
          },
          {
            text: 'Bilet No',
            value: 'BiletNo'
          },
          {
            text: 'Uçuş Tipi',
            value: 'UcusTip'
          },
          {
            text: 'Açıklama',
            value: ''
          }

        ],
        satisIc: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },



        iadeic: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },

        iadeDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        iadeGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        genic: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },

        gendis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        gengen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        Rapor: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HavaYoluKodu: null,
          AcentaKodu: null,
          Masraf: null,
          OdemeTipi: 0, // 0 : hepsi, 1 : peşin, 2 : kredi kart
          RaporSira: 0, // 0 : Bilet sirası, 1 : Tarih sirasi
          HatTipi: 0 // 0 : hepsi, 1 : iç, 2 : dis, 3 : Dis, 4 : Bsp, 5 : bsp+dis
        },

        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,

        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],


        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },


    components: {
      'tarihcomp': tarihcomp,
      havayollaricomp,
      parkurcomp
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }




    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })


  }




  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.KesenKisi = null
    this.Rapor.Cari.Kod = null
    this.Rapor.Havayolu.HavaYoluKodu = null
    this.Rapor.AnaHesap = null
    this.Rapor.HesapGrubu = null
    this.Rapor.Doviz.DovizKod = null
    this.Rapor.AcentaKodu = null
    this.Rapor.FiyatTuru = null
    this.Rapor.Masraf.Code = null
    this.Rapor.DepatmanKodu = null
    this.Rapor.Opsiyonlar.SiraTip = null
    this.Rapor.Opsiyonlar.RaporTip = null
    this.Rapor.Opsiyonlar.HatTip = null
    this.Rapor.Opsiyonlar.OdemeTip = null
    this.Rapor.Opsiyonlar.DovizTl = null
    this.Rapor.Opsiyonlar.DetayOzet = null
    this.Rapor.Opsiyonlar.KesimTarihi = null
    this.Rapor.Opsiyonlar.GeciciHesap = null
    this.Rapor.Opsiyonlar.IadeFatDekont = null
  }





  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
        this.Rapor.AcentaKodu=this.havayolubil2.havayolukodu;

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketPeriodReport/NonIataPeriodReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {


          // this.itemssatis = response.body.SatisBilgi.Detay
          // this.itemsiade = response.body.IadeBilgi.Detay
          // this.itemsvoid = response.body.VoidBilgi.Detay


          // this.satisIc = response.body.SatisBilgi.ToplamIcHat
          // this.satisDis = response.body.SatisBilgi.ToplamDisHat
          // this.satisGen = response.body.SatisBilgi.ToplamGenel

          // //toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

          // if (response.body.IadeBilgi.Detay.length > 0) {
          //   this.iadeic = response.body.IadeBilgi.ToplamIcHat
          //   this.iadeDis = response.body.IadeBilgi.ToplamDisHat
          //   this.iadeGen = response.body.IadeBilgi.ToplamGenel
          // }


          // this.genic = response.body.IchatToplamlar
          // this.gendis = response.body.DisHatToplamlar
          // this.gengen = response.body.GenelToplamlar



          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }

        })

    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {

      if (this.havayolubil.havayolukodu != null) {
        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
        this.Rapor.AcentaKodu=this.havayolubil2.havayolukodu;

        var params = this.Rapor

    this.$http
      .post(auth.API_URL + "api/TicketPeriodReport/NonIataPeriodReportHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "NonIataDevre.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
      } else {
        this.text1 = 'Havayolu Kodu Giriniz..'
        this.snackbar = true
      }
    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      if (this.havayolubil.havayolukodu != null) {
        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
        this.Rapor.AcentaKodu=this.havayolubil2.havayolukodu;

        var params = this.Rapor

    this.$http
      .post(auth.API_URL + "api/TicketPeriodReport/NonIataPeriodReportExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "NonIataDevre.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
      } else {
        this.text1 = 'Havayolu Kodu Giriniz..'
        this.snackbar = true
      }
    }
  }

  function beforeMount() {
    this.Rapor.BaslangicTarih = getDateNow()
    this.Rapor.BitisTarih = getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })
  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>
<style>
</style>